// eslint-disable-next-line import/prefer-default-export
export const isSuspensionActive = (date) => date > Date.now();
